import { axios, BaseApiUrl,BaseUrl} from '../axios_config';

///仓库费用配置
export const GetWarehouseFeeItemList = params => {
    return axios.post(`${BaseApiUrl}/WarehouseCostConfigure/GetWarehouseFeeItemList`, { ...params }).then(res => res.data);
};

///下拉费用类型
export const GetFeeTypeList = params => {
    return axios.post(`${BaseApiUrl}/WarehouseCostConfigure/GetFeeTypeList`, { ...params }).then(res => res.data);
};

////下拉费用项
export const GetFeeItemList = params => {
    return axios.post(`${BaseApiUrl}/WarehouseCostConfigure/GetFeeItemList`, { ...params }).then(res => res.data);
};


////下拉费用项
export const UpdateFeeItemStatus = params => {
    return axios.post(`${BaseApiUrl}/WarehouseCostConfigure/UpdateFeeItemStatus`, { ...params }).then(res => res.data);
};


///下拉费用类型
export const GetFeeTypeAllList = params => {
    return axios.post(`${BaseApiUrl}/WarehouseCostConfigure/GetFeeTypeAllList`, { ...params }).then(res => res.data);
};

////下拉费用项
export const GetFeeItemAllList = params => {
    return axios.post(`${BaseApiUrl}/WarehouseCostConfigure/GetFeeItemAllList`, { ...params }).then(res => res.data);
};


////费用项维护提交
export const FeeItemSubmit = params => {
    return axios.post(`${BaseApiUrl}/WarehouseCostConfigure/FeeItemSubmit`, { ...params }).then(res => res.data);
};
